"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifThen = ifThen;
exports.ifElse = ifElse;
exports.default = void 0;

/**
 * @public
 * @description Returns a css if and ONLY if condition is true.
 * @param {boolean} conditions
 * @param {string} returnTrue
 * @returns {*}
 */
function ifThen(conditions, returnTrue) {
  return ifElse(conditions, returnTrue, '');
}
/**
 * @public
 * @description Returns a different css depending on condition value.
 * @param {boolean} conditions
 * @param {string} returnTrue
 * @param {string} returnFalse
 * @returns {*}
 */


function ifElse(conditions, returnTrue, returnFalse) {
  return conditions ? returnTrue : returnFalse;
}

var _default = {
  ifThen: ifThen,
  ifElse: ifElse
};
exports.default = _default;